export default __webpack_public_path__ + "static/media/NoRacesMascot.4d3cfa51.png";